export default "__VITE_ASSET__C$$uWa4B__"